import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useAppcuesScript from './useAppcuesScript';
import UserRoles from 'utils/userRoles';
import { USER_ROLE } from 'utils/constants/users';

export default function useInitAppCues() {
    useAppcuesScript();
    const location = useLocation();
    const user = useSelector((state) => state.auth.user);
    const { cm, em } = useSelector((state) => state?.Community?.myCommunity);
    const { ORGANIZER } = USER_ROLE;

    const enableAppcuesInLiveEvent =
        UserRoles?.roles?.[user?.id]?.role === ORGANIZER;
    const enableAppcuesElsewhere = user?.id && (cm?.length || em?.length);

    useEffect(() => {
        if (
            window.Appcues &&
            (enableAppcuesElsewhere || enableAppcuesInLiveEvent)
        ) {
            window.Appcues.page();
            user?.id &&
                window.Appcues.identify(user.id, {
                    firstName: user.first_name,
                    lastName: user.last_name,
                    email: user.email,
                    communityId: user.community?.communityId,
                });
        }
    }, [
        location.pathname,
        enableAppcuesElsewhere,
        enableAppcuesInLiveEvent,
        user,
    ]);
}
